import { render } from "./InviteNewUser.vue?vue&type=template&id=0631e3a6&scoped=true"
import script from "./InviteNewUser.vue?vue&type=script&lang=js"
export * from "./InviteNewUser.vue?vue&type=script&lang=js"

import "./InviteNewUser.vue?vue&type=style&index=0&id=0631e3a6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0631e3a6"]])

export default __exports__